module.exports = __webpack_public_path__ + "carousel_05_img_02.png?60579ddd30ee3703e433268e4ca555fd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel_05_img_02.png
// module id = 163
// module chunks = 0